import React from 'react';
import { IconProps } from '.';

type PapersIconProps = {
  color?: string;
} & IconProps;

export const PapersIcon: React.FC<PapersIconProps> = ({
  width = 24,
  height = 24,
  color = '#222427',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 19 21"
    >
      <path
        fill={color}
        d="M14.406 13.833h-8a.427.427 0 000 .854h8a.427.427 0 100-.854zM14.406 11.198h-8a.427.427 0 000 .844h8a.427.427 0 000-.844zM14.406 8.604h-8a.427.427 0 000 .844h8a.427.427 0 000-.844zM6.406 6.833h3.615a.427.427 0 000-.843H6.406a.427.427 0 000 .843z"
      ></path>
      <path
        fill={color}
        d="M17.74 2.958L15.135.385a1.042 1.042 0 00-.729-.302H4.104a1.042 1.042 0 00-1.042 1.042v16.667a1.042 1.042 0 001.042 1.041H17a1.042 1.042 0 001.042-1.041V3.698a1.042 1.042 0 00-.302-.74zm-.886.313h-2.083v-2l2.083 2zM17 17.948H4.104a.198.198 0 01-.198-.198V1.083a.198.198 0 01.198-.208h9.906v2.77a.428.428 0 00.428.428h2.791v13.625a.198.198 0 01-.198.198"
      ></path>
      <path
        fill={color}
        d="M15.49 19.438a.427.427 0 00-.428.416.207.207 0 01-.208.219H2.01a.219.219 0 01-.218-.219V3.188a.219.219 0 01.218-.22.427.427 0 000-.843A1.042 1.042 0 00.97 3.167v16.667a1.042 1.042 0 001.041 1.041h12.844a1.041 1.041 0 001.042-1.041.417.417 0 00-.417-.417"
      ></path>
    </svg>
  );
};
